module.exports = __webpack_public_path__ + "img/XANG_DAU_KHI_DOT.dbd1a672.svg";